import React from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";

import logo from "./imgs/logo.png";

export default class MyNavbar extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  gotoMenu = menu => {
    this.props.refss(menu);
  };

  render() {
    return (
      <div>
        <div className="bg-top">
          <a href="tel:02423257636">
            Contact Us: <i className="fas fa-phone-volume" /> 02423-257636
          </a>
        </div>

        <Navbar color="light" light expand="md">
          <NavbarBrand href="/">
            <img src={logo} width="90" alt="logo" />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink
                  className="nav-link"
                  onClick={() => this.gotoMenu("home")}
                >
                  Home
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className="nav-link"
                  onClick={() => this.gotoMenu("channels")}
                >
                  Channel Packs
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className="nav-link"
                  onClick={() => this.gotoMenu("about")}
                >
                  About Us
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}
